
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}

const StatsCard = ({ title, value, icon, trend, className }: StatsCardProps) => {
  return (
    <div className={cn(
      "card-stats relative overflow-hidden transition-all card-glow w-full min-w-0", 
      className
    )}>
      <div className="flex justify-between items-start">
        <div className="min-w-0 flex-1">
          <p className="text-sm text-muted-foreground truncate">{title}</p>
          <p className="text-xl sm:text-2xl font-semibold mt-2 break-words">{value}</p>
          
          {trend && (
            <div className="flex items-center mt-2">
              <span className={`text-xs ${trend.isPositive ? 'text-recallio-green' : 'text-red-400'}`}>
                {trend.isPositive ? '+' : '-'}{Math.abs(trend.value)}%
              </span>
              <span className="text-xs text-muted-foreground ml-1">vs last month</span>
            </div>
          )}
        </div>
        
        <div className="p-2 rounded-md bg-recallio-medium-gray flex-shrink-0">
          {icon}
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-linear from-recallio-yellow to-recallio-green opacity-30" />
    </div>
  );
};

export default StatsCard;
